import { render, staticRenderFns } from "./ComplainIndex.vue?vue&type=template&id=478a50ff&"
import script from "./ComplainIndex.vue?vue&type=script&lang=js&"
export * from "./ComplainIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports